import getConfig from '~/config';

/*const app = {
    title: 'WebSail',
    logo: '/img/logo_white.png',
    company: 'Marina Lanke',

    menu: [
        {
            icon: 'person',
            children: [
                { label: 'Customers', 'value': 'customers'},
            ]
        },
        {
            icon: 'BillingIcon',
            children: [
                { children: [
                    { label: 'Invoices', value: 'bills' },
                    { label: 'Payments', value: 'payments' },
                ]},
            ]
        }
    ]
};*/

const config = getConfig();
const locale = getConfig().locale;
const showHarbour = config.showHarbour;
const showExams = !config.hideExams;
const moneySign = locale === 'en' ? 'pound' : 'euro';

const app = {
    appPageTitles: {
        map: 'Hafenansicht',
    },

    menu: [
        {
            type: 'major',
            icon: 'person',
            tooltip: 'menuTooltips.customerGroup',
            children: [
                { label: 'menu.customers', tooltip: 'menuTooltips.customers', 'value': 'customers'},
                { label: 'menu.outgoingMessages', tooltip: 'menuTooltips.outgoingMessages', 'value': 'outgoing_messages'},
            ]
        },
        {
            type: 'major',
            icon: config.middleIcon,
            tooltip: 'menuTooltips.courseGroup',
            children: [
                { label: 'menu.courses', value: 'course_timespans', tooltip: 'menuTooltips.course_timespans'  },
                { label: 'menu.scheduling', value: 'scheduling_timespans', tooltip: 'menuTooltips.scheduling'  },
                { label: 'menu.bookings', value: 'participants', tooltip: 'menuTooltips.bookings' },
                showExams && { label: 'menu.exams', value: 'exams', tooltip: 'menuTooltips.exams',  },
                showExams && { label: 'menu.exam_booking', value: 'exam_booking', tooltip: 'menuTooltips.exam_booking' },
            ].filter(v => v)
        },

        showHarbour && {
            tooltip: 'menuTooltips.harbour',
            type: 'major',
            icon: 'anchor2',
            children: [
                { label: 'Hafenübersicht', 'value': 'map'},
                { label: 'Boote', 'value': 'boats'},
            ]
        },

        {
            type: 'major',
            tooltip: 'menuTooltips.billing',
            icon: moneySign,
            children: [
                { children: [
                    { label: 'menu.bills', value: 'bills', tooltip: 'menuTooltips.bills' },
                    { label: 'menu.payments', value: 'payments', tooltip: 'menuTooltips.payments' },
                    { label: 'menu.bank_transactions', value: 'bank_transactions', tooltip: 'menuTooltips.bank_transactions' },
                    { label: 'menu.sepa_direct_debit_mandates', value: 'sepa_direct_debit_mandates', tooltip: 'menuTooltips.sepa_direct_debit_mandates' },
                    { label: 'menu.articles', 'value': 'articles', tooltip: 'menuTooltips.articles'},
                ]}
            ]
        },

        {
            tooltip: 'menuTooltips.search',
            icon: 'search',
            value: 'search',
            type: 'minor',
        },

        {
            icon: 'add',
            type: 'minor',
            tooltip: 'menuTooltips.addFast',
            children: [
                { label: 'menu.customer', value: 'customers/new', tooltip: 'menuTooltips.new_customer' },
                { label: 'menu.booking', value: "book", tooltip: 'menuTooltips.new_booking' },
                { label: 'menu.bill', value: 'bills/new', tooltip: 'menuTooltips.new_bill' },
                { label: 'menu.payment', value: 'payments/new', tooltip: 'menuTooltips.new_payment' },
                showExams && { label: 'menu.exam_booking_single', value: 'exam_booking/new', tooltip: 'menuTooltips.new_exam_booking' }
            ].filter(v => v),
        },

        {
            icon: 'settings',
            tooltip: 'menuTooltips.settings',
            type: 'minor',
            children: [
                { children: [
                        { label: 'menu.courseCategories', value: 'courses', tooltip: 'menuTooltips.courses' },
                        showExams && { label: 'menu.examCategories', value: 'exam_types', tooltip: 'menuTooltips.exam_types' },
                        showExams && { label: 'menu.partialExams', value: 'partial_exams', tooltip: 'menuTooltips.partial_exams' },
                ].filter(v => v)},
                showHarbour && { children: [
                        { label: 'Yachtmodelle', 'value': 'boat_types'},
                        { label: 'Stege', 'value': 'mooring_types'},
                ]},
                { children: [
                    { label: 'menu.articleTypes', 'value': 'article_types', tooltip: 'menuTooltips.article_types'},
                ]},
                { children: [
                        { label: 'menu.employees', 'value': 'users', tooltip: 'menuTooltips.employees'},
                ]},
                { children: [
                    { label: 'menu.places', value: 'places', tooltip: 'menuTooltips.places' },
                    // { label: 'menu.templates', value: 'document_templates' },
                    { label: 'menu.message_templates', value: 'message_templates', tooltip: 'menuTooltips.message_templates' },
                    { label: 'menu.files', value: 'files', tooltip: 'menuTooltips.files' },
                    // { label: 'menu.taxes', value: 'tax_rates' },
                    // { label: 'menu.salutations', value: 'salutations' },
                    // { label: 'menu.content_blocks', value: 'content_blocks' },
                    // { label: 'menu.options', value: 'basic_options' },
                    { label: 'menu.consents', value: 'consents', tooltip: 'menuTooltips.consents' },
                    { label: 'menu.consent_user', value: 'consent_user', tooltip: 'menuTooltips.consent_user' },
                    { label: 'menu.tags', value: 'tags', tooltip: 'menuTooltips.tags' },
                    // { label: 'menu.tag_types', value: 'tag_types' },
                    { label: 'menu.banks', value: 'banks', tooltip: 'menuTooltips.banks' },
                    { label: 'menu.payment_gateway_configs', value: 'payment_gateway_configs', tooltip: 'menuTooltips.payment_gateway_configs' },
                ]},
            ].filter(v => v)
        },

        {
            icon: 'help',
            type: 'minor',
            label: 'menu.help',
            tooltip: 'menuTooltips.help',
            children: [
                // { label: 'menu.openHelp', 'value': 'help' },
                // { label: 'menu.hideTooltips', 'value': 'hideTooltips', tooltip: 'menuTooltips.hideTooltips' },
                // { label: 'menu.showTooltips', 'value': 'showTooltips', tooltip: 'menuTooltips.showTooltips' },
                { label: 'menu.openHelp', 'value': 'https://docs.google.com/document/d/1D06Pt5o--xAQ34FbQhHX8ITBZ7XHS6muHiyzSsK02QI/edit?usp=sharing', tooltip: 'menuTooltips.openHelp' },
                { label: 'menu.aboutUs', 'value': 'aboutUs' },
                { label: "menu.downloadOnAndroid", value: "https://play.google.com/store/apps/details?id=de.veranstaltungsbutler.vbticketscanner" },
                { label: "menu.downloadOniOS", value: "https://apps.apple.com/us/app/veranstaltungsbutler-scanner/id1560871197" },
                { label: 'menu.loginOnMobile', value: "mobile_login" },
            ]
        },
    ].filter(v => v)
};


export default app;